// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__uIEoR","content":"Menu_content__u6Ucy"};